import { useEffect, useState } from 'react';
import './App.css';

const toSlug = (value) =>
  value
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');

const toAirportSlug = (value) =>
  value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');

function ButtonIcon({ type }) {
  if (type === 'phone') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M7.2 10.8a15.2 15.2 0 0 0 6 6l2-2a1.5 1.5 0 0 1 1.5-.4 10.8 10.8 0 0 0 3.4.5 1.5 1.5 0 0 1 1.5 1.5V20a1.5 1.5 0 0 1-1.5 1.5C11 21.5 2.5 13 2.5 2.5A1.5 1.5 0 0 1 4 1h3.6A1.5 1.5 0 0 1 9.1 2.5c0 1.2.2 2.4.5 3.5a1.5 1.5 0 0 1-.4 1.5l-2 1.9Z" />
      </svg>
    );
  }

  if (type === 'quote') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 3h16a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm10 4v2h3v7h-3v2h5V7h-5Zm-9 4h6v2H5v-2Z" />
      </svg>
    );
  }

  if (type === 'airport') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M11 2h2v6l8 4v2l-8-2.5V22h-2V11.5L3 14v-2l8-4V2Z" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M5 11h1l1.2-3.6A2 2 0 0 1 9.1 6h5.8a2 2 0 0 1 1.9 1.4L18 11h1a2 2 0 0 1 2 2v3h-2v2a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-2H8v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-2H3v-3a2 2 0 0 1 2-2Zm3.5-3.5L7.7 11h8.6l-.8-3.5a.5.5 0 0 0-.5-.4H9a.5.5 0 0 0-.5.4Zm-.5 6a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4Zm8 0a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4Z" />
    </svg>
  );
}

function FooterInfoIcon({ type }) {
  if (type === 'address') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 2a7 7 0 0 0-7 7c0 5.1 7 13 7 13s7-7.9 7-13a7 7 0 0 0-7-7Zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z" />
      </svg>
    );
  }

  if (type === 'email') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M3 5h18a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm9 7.2L4.2 7h15.6L12 12.2Z" />
      </svg>
    );
  }

  if (type === 'whatsapp') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 2a10 10 0 0 0-8.8 14.8L2 22l5.4-1.1A10 10 0 1 0 12 2Zm0 18a8 8 0 0 1-4-1.1l-.3-.1-3.2.7.7-3.1-.2-.3A8 8 0 1 1 12 20Zm4.2-5.6c-.2-.1-1.2-.6-1.4-.7-.2-.1-.3-.1-.5.1l-.7.8c-.1.1-.2.2-.4.1-1.2-.6-2.2-1.4-3-2.5-.2-.2 0-.3.1-.4l.5-.6c.1-.2.2-.3.2-.5s0-.3-.1-.4l-.6-1.4c-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.4.1-.6.3-.8.8-1 2-.3 3.3 1.1 2.1 2.9 3.8 5 4.8 1.4.7 2.4.6 3.3.4.5-.2 1.1-.8 1.2-1.5.1-.3.1-.6 0-.7-.1-.1-.3-.2-.5-.3Z" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M7.2 10.8a15.2 15.2 0 0 0 6 6l2-2a1.5 1.5 0 0 1 1.5-.4 10.8 10.8 0 0 0 3.4.5 1.5 1.5 0 0 1 1.5 1.5V20a1.5 1.5 0 0 1-1.5 1.5C11 21.5 2.5 13 2.5 2.5A1.5 1.5 0 0 1 4 1h3.6A1.5 1.5 0 0 1 9.1 2.5c0 1.2.2 2.4.5 3.5a1.5 1.5 0 0 1-.4 1.5l-2 1.9Z" />
    </svg>
  );
}

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedServiceSlug, setSelectedServiceSlug] = useState('');
  const [selectedAirportTitle, setSelectedAirportTitle] = useState('');
  const [activeTestimonialIndex, setActiveTestimonialIndex] = useState(0);
  const callNumber = '013 15818499';
  const callTel = callNumber.replace(/\s+/g, '');
  const whatsappNumber = '07365874733';
  const whatsappLink = 'https://wa.me/447365874733';
  const emailAddress = 'info@edinburghtaxicabs.co.uk';

  const navItems = [
    { label: 'Home', href: '#home' },
    { label: 'About Us', href: '#about' },
    { label: 'Our Services', href: '#services' },
    { label: 'Airport Transfers', href: '#airport-transfers' },
    { label: 'Contact Us', href: '#contact' },
  ];

  const ctaItems = [
    {
      label: 'Call Now',
      href: `tel:${callTel}`,
      className: 'cta-call',
      icon: 'phone',
    },
    {
      label: 'Get Quotation',
      href: 'https://booktaxinow.co.uk/',
      className: 'cta-quote',
      icon: 'quote',
      external: true,
    },
    {
      label: 'Book Now',
      href: 'https://booktaxinow.co.uk/',
      className: 'cta-book',
      icon: 'car',
      external: true,
    },
    {
      label: 'Airport Booking',
      href: 'https://booktaxinow.co.uk/',
      className: 'cta-airport',
      icon: 'airport',
      external: true,
    },
  ];

  const services = [
    {
      title: 'Airport Transfers',
      desc: 'Edinburg Taxicabs provides reliable and on-time airport transfers, ensuring a smooth and stress-free journey to and from the airport.',
      img: '/Airport Transfers.jfif',
      detail:
        'Edinburg Taxicabs provides reliable and on-time airport transfer services in Edinburg, ensuring passengers reach their destination without any stress or delay. Edinburg Taxicabs focuses on comfort, punctuality, and smooth travel experience for both arrivals and departures. With professional drivers and well-maintained vehicles, Edinburg Taxicabs makes airport journeys easy and dependable.',
    },
    {
      title: 'Free Child & Baby Seats',
      desc: 'Edinburg Taxicabs offers free child and baby seats to ensure safe and comfortable travel for families.',
      img: '/Free Child & Baby Seats.jfif',
      detail:
        'Edinburg Taxicabs offers free child and baby seat facilities in Edinburg to ensure safe and secure travel for families with young children. Edinburg Taxicabs prioritizes passenger safety by providing properly fitted seats for infants and kids. Families can enjoy comfortable journeys knowing Edinburg Taxicabs takes care of their safety needs.',
    },
    {
      title: 'Meet & Greet Service',
      desc: 'Edinburg Taxicabs includes a friendly meet and greet service, where drivers welcome you at the airport with ease.',
      img: '/Meet-and-Ssisst-airport-services.jpg',
      detail:
        'Edinburg Taxicabs provides a professional meet & greet service at Edinburg airport where drivers warmly welcome passengers upon arrival. Edinburg Taxicabs assists with luggage handling and guides passengers smoothly to their vehicles. This service ensures a stress-free and welcoming airport experience with Edinburg Taxicabs.',
    },
    {
      title: '24/7 Taxi Service',
      desc: 'Edinburg Taxicabs operates 24/7, so you can book a ride anytime, day or night.',
      img: '/247 Taxi Service.jfif',
      detail:
        'Edinburg Taxicabs operates a 24/7 taxi service in Edinburg, allowing passengers to book rides at any time of the day or night. Edinburg Taxicabs ensures that transportation is always available, regardless of time or urgency. With round-the-clock service, Edinburg Taxicabs provides maximum convenience for all customers.',
    },
    {
      title: 'Executive & Business Travel',
      desc: 'Edinburg Taxicabs delivers comfortable and premium travel solutions tailored for business and executive needs.',
      img: '/Executive & Business Travel.jpg',
      detail:
        'Edinburg Taxicabs offers premium executive and business travel services in Edinburg designed for corporate clients and professionals. Edinburg Taxicabs ensures privacy, comfort, and high-quality service for meetings, conferences, and official trips. Business travelers rely on Edinburg Taxicabs for a smooth and professional travel experience.',
    },
    {
      title: 'City-to-City Transfers',
      desc: 'Edinburg Taxicabs offers convenient city-to-city transfers with comfort and reliability.',
      img: '/City-to-City Transfers.jfif',
      detail:
        'Edinburg Taxicabs provides reliable city-to-city transfer services from Edinburg, making intercity travel simple and comfortable. Edinburg Taxicabs ensures safe long-distance journeys with experienced drivers and well-maintained vehicles. Passengers can travel between cities with confidence using Edinburg Taxicabs.',
    },
    {
      title: 'Minibus & Group Travel',
      desc: 'Edinburg Taxicabs provides spacious minibuses, perfect for group travel and family trips.',
      img: '/Minibus & Group Travel.jpg',
      detail:
        'Edinburg Taxicabs offers spacious minibus and group travel services in Edinburg, perfect for families, events, and group tours. Edinburg Taxicabs provides comfortable seating and ample space for multiple passengers and luggage. Group travel becomes easy and enjoyable with Edinburg Taxicabs.',
    },
    {
      title: 'Wheelchair Accessible Vehicles',
      desc: 'Edinburg Taxicabs ensures accessible travel with vehicles designed for wheelchair users.',
      img: '/Wheelchair Accessible Vehicles.jfif',
      detail:
        'Edinburg Taxicabs provides wheelchair accessible vehicles in Edinburg to ensure inclusive and comfortable travel for all passengers. Edinburg Taxicabs is committed to supporting passengers with mobility needs through specially designed vehicles. Everyone can travel safely and independently with Edinburg Taxicabs.',
    },
    {
      title: 'Pet-Friendly Taxi Service',
      desc: 'Edinburg Taxicabs welcomes pets, making your journeys easy and stress-free with your furry companions.',
      img: '/Pet-Friendly Taxi Service.jpg',
      detail:
        'Edinburg Taxicabs offers pet-friendly taxi services in Edinburg, allowing passengers to travel with their pets comfortably. Edinburg Taxicabs ensures a safe and relaxed environment for both passengers and their animals. Pet owners can travel without worry using Edinburg Taxicabs.',
    },
    {
      title: 'Courier & Parcel Delivery',
      desc: 'Edinburg Taxicabs offers fast and secure courier and parcel delivery services across the city.',
      img: '/Courier & Parcel Delivery.webp',
      detail:
        'Edinburg Taxicabs provides fast and secure courier and parcel delivery services in Edinburg for both personal and business needs. Edinburg Taxicabs ensures safe handling and timely delivery of packages across the city. Customers trust Edinburg Taxicabs for reliable delivery solutions.',
    },
    {
      title: 'Long Distance Journeys',
      desc: 'Edinburg Taxicabs provides comfortable long-distance travel with reliable and experienced drivers.',
      img: '/Long Distance Journeys.jfif',
      detail:
        'Edinburg Taxicabs offers long-distance travel services from Edinburg with comfort and safety as top priorities. Edinburg Taxicabs uses experienced drivers to ensure smooth journeys over long routes. Passengers can relax and enjoy stress-free travel with Edinburg Taxicabs.',
    },
    {
      title: 'Easy Online Booking',
      desc: 'Edinburg Taxicabs makes booking simple and quick through an easy online system.',
      img: '/Easy Online Booking.jpg',
      detail:
        'Edinburg Taxicabs provides an easy online booking system in Edinburg, making ride reservations quick and simple. Edinburg Taxicabs allows customers to book taxis within minutes through a user-friendly platform. Convenience and efficiency are the main focus of Edinburg Taxicabs.',
    },
    {
      title: 'Secure Online Payments',
      desc: 'Edinburg Taxicabs supports safe and secure online payment options for your convenience.',
      img: '/Secure Online Payments.jpg',
      detail:
        'Edinburg Taxicabs supports secure online payment options in Edinburg for safe and hassle-free transactions. Edinburg Taxicabs ensures all payments are protected with advanced security systems. Customers can pay confidently using Edinburg Taxicabs.',
    },
    {
      title: 'Extra Luggage Transfers',
      desc: 'Edinburg Taxicabs accommodates extra luggage, ensuring a hassle-free travel experience.',
      img: '/Extra Luggage Transfers.jfif',
      detail:
        'Edinburg Taxicabs accommodates extra luggage in Edinburg, making travel easier for passengers with heavy or additional baggage. Edinburg Taxicabs provides vehicles with sufficient space for all luggage needs. Passengers can travel comfortably without luggage concerns using Edinburg Taxicabs.',
    },
    {
      title: 'Flight Monitoring & Delay Tracking',
      desc: 'Edinburg Taxicabs tracks your flight in real-time to adjust pickup times according to delays.',
      img: '/Flight Monitoring & Delay Tracking.webp',
      detail:
        'Edinburg Taxicabs offers real-time flight monitoring in Edinburg to adjust pickup times according to delays or early arrivals. Edinburg Taxicabs ensures drivers are always updated with flight schedules for smooth coordination. This service guarantees a stress-free airport pickup experience with Edinburg Taxicabs.',
    },
  ];

  const airportTransferCards = [
    {
      title: 'Edinburgh Airport',
      summary:
        'Reliable and professional transfer services to and from Edinburgh Airport with punctual pickups and comfortable vehicles.',
      description:
        'Edinburg Taxicabs provides reliable and professional transfer services to and from Edinburgh Airport, ensuring a smooth and stress-free journey for all passengers. Edinburg Taxicabs is committed to punctual pickups and drop-offs, so you never have to worry about delays or missed flights. With a fleet of clean, comfortable vehicles and experienced drivers, Edinburg Taxicabs guarantees a safe and relaxing ride. Whether you are traveling for business or leisure, Edinburg Taxicabs offers tailored solutions to meet your needs. Additionally, Edinburg Taxicabs monitors flight schedules in real-time to adjust pickup timings, ensuring maximum convenience and peace of mind.',
    },
    {
      title: 'Dundee Airport',
      summary:
        'Efficient and comfortable taxi services between Edinburg and Dundee Airport for simple, hassle-free travel.',
      description:
        'Edinburg Taxicabs offers efficient and comfortable taxi services between Edinburg and Dundee Airport, making long-distance travel simple and hassle-free. Edinburg Taxicabs focuses on delivering timely and reliable transfers with professional drivers who ensure a smooth journey. All vehicles are well-maintained and designed to provide maximum comfort throughout your trip. Edinburg Taxicabs is an ideal choice for both individual travelers and families looking for dependable airport transportation. With a strong commitment to safety and customer satisfaction, Edinburg Taxicabs ensures a pleasant travel experience every time.',
    },
    {
      title: 'Glasgow Airport',
      summary:
        'Premium transfer service from Edinburg to Glasgow Airport with comfort, reliability, and on-time arrivals.',
      description:
        'Edinburg Taxicabs provides premium transfer services from Edinburg to Glasgow Airport with a strong focus on comfort, reliability, and professionalism. Edinburg Taxicabs ensures on-time service so passengers can travel without stress or unnecessary delays. The service includes experienced drivers who are familiar with the best routes to guarantee a smooth journey. Edinburg Taxicabs offers a range of vehicles suitable for both individuals and groups. Whether it is an early morning flight or a late-night arrival, Edinburg Taxicabs is always ready to serve.',
    },
    {
      title: 'Glasgow Prestwick Airport',
      summary:
        'Long-distance transfers to Glasgow Prestwick Airport with spacious vehicles and dependable service.',
      description:
        'Edinburg Taxicabs offers long-distance transfer services from Edinburg to Glasgow Prestwick Airport, ensuring a comfortable and secure travel experience. Edinburg Taxicabs prioritizes punctuality and customer satisfaction by providing reliable pickups and drop-offs. The vehicles are spacious, clean, and equipped to handle both passengers and luggage with ease. Edinburg Taxicabs drivers are highly trained and committed to providing a smooth and safe journey. This makes Edinburg Taxicabs a trusted choice for airport transfers.',
    },
    {
      title: 'Newcastle Airport',
      summary:
        'Dependable long-distance airport transfers to Newcastle Airport with safe, modern, and comfortable rides.',
      description:
        'Edinburg Taxicabs provides dependable transfer services from Edinburg to Newcastle Airport, making long-distance travel convenient and stress-free. Edinburg Taxicabs ensures safe and comfortable journeys with experienced drivers and modern vehicles. The service is designed to meet the needs of both business and leisure travelers. Edinburg Taxicabs focuses on delivering timely service while maintaining high standards of comfort and safety. Passengers can enjoy a relaxed and reliable travel experience with Edinburg Taxicabs.',
    },
  ];

  const testimonials = [
    {
      quote:
        'Booked a late-night pickup and the driver arrived right on time. The whole ride across Edinburgh was smooth, clean, and very comfortable.',
      name: 'Amina R.',
      location: 'Edinburgh',
    },
    {
      quote:
        'Excellent airport transfer service. We had extra luggage and everything was handled professionally from our Edinburgh home to the terminal.',
      name: 'Daniel M.',
      location: 'Edinburgh',
    },
    {
      quote:
        'I use this taxi service regularly for business meetings. Reliable timings, polite drivers, and a premium feel every time in Edinburgh.',
      name: 'Sarah K.',
      location: 'Edinburgh',
    },
    {
      quote:
        'Great experience for family travel. Child seat was ready as requested and the booking process was quick and easy in Edinburgh.',
      name: 'Usman A.',
      location: 'Edinburgh',
    },
    {
      quote:
        'Friendly team and quick response on WhatsApp. They made our city-to-city journey from Edinburgh stress-free and well managed.',
      name: 'Rebecca T.',
      location: 'Edinburgh',
    },
  ];

  useEffect(() => {
    const handleHashChange = () => {
      const rawHash = window.location.hash.replace('#', '');
      
      // Handle airport transfers
      if (rawHash.startsWith('airport-')) {
        const airportSlug = rawHash.replace('airport-', '');
        const airport = airportTransferCards.find((a) => toAirportSlug(a.title) === airportSlug);
        setSelectedAirportTitle(airport ? airport.title : '');
        setSelectedServiceSlug('');
        return;
      }
      
      // Handle services
      if (rawHash.startsWith('service-')) {
        const slug = rawHash.replace('service-', '');
        const exists = services.some((service) => toSlug(service.title) === slug);
        setSelectedServiceSlug(exists ? slug : '');
        setSelectedAirportTitle('');
        return;
      }

      setSelectedServiceSlug('');
      setSelectedAirportTitle('');
    };

    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveTestimonialIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 3800);

    return () => clearInterval(timer);
  }, [testimonials.length]);

  const selectedService = services.find((service) => toSlug(service.title) === selectedServiceSlug);
  const selectedAirport = airportTransferCards.find((airport) => airport.title === selectedAirportTitle);

  const handleOpenService = (service) => {
    const slug = toSlug(service.title);
    setSelectedServiceSlug(slug);
    window.location.hash = `service-${slug}`;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleBackToServices = () => {
    setSelectedServiceSlug('');
    window.location.hash = 'services';
    const target = document.querySelector('#services');
    if (target) {
      requestAnimationFrame(() => {
        const header = document.querySelector('.site-header');
        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        const targetTop = target.getBoundingClientRect().top + window.scrollY - headerHeight - 8;
        window.scrollTo({ top: Math.max(targetTop, 0), behavior: 'smooth' });
      });
    }
  };

  const handleReadAirport = (airport) => {
    const airportSlug = toAirportSlug(airport.title);
    window.location.hash = `airport-${airportSlug}`;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const renderCtaLabel = (label) => {
    const words = label.split(' ');
    const top = words[0] || label;
    const bottom = words.slice(1).join(' ') || '';

    return (
      <span className="cta-text">
        <span className="cta-line-top">{top}</span>
        <span className="cta-line-bottom">{bottom}</span>
      </span>
    );
  };

  const handleNavClick = (event, href) => {
    if (!href.startsWith('#')) {
      return;
    }

    event.preventDefault();
    setMenuOpen(false);
    setSelectedServiceSlug('');
    setSelectedAirportTitle('');

    const targetHash = href.replace('#', '');
    window.location.hash = targetHash;

    const scrollToTarget = (attempt = 0) => {
      const target = document.querySelector(href);
      if (!target) {
        if (attempt < 8) {
          requestAnimationFrame(() => scrollToTarget(attempt + 1));
        }
        return;
      }

      const header = document.querySelector('.site-header');
      const headerHeight = header ? header.getBoundingClientRect().height : 0;
      const targetTop = target.getBoundingClientRect().top + window.scrollY - headerHeight - 8;
      window.scrollTo({ top: Math.max(targetTop, 0), behavior: 'smooth' });
    };

    requestAnimationFrame(() => scrollToTarget());
  };

  return (
    <div className="site-shell">
      <header className="site-header">
        <div className="top-strip">
          <div className="container top-strip-inner">
            <p>Available 24/7 Across Edinburgh</p>
            <div className="top-strip-links">
              <a href={`tel:${callTel}`}>
                <span aria-hidden="true">
                  <FooterInfoIcon type="phone" />
                </span>
                {callNumber}
              </a>
              <a href={`mailto:${emailAddress}`}>
                <span aria-hidden="true">
                  <FooterInfoIcon type="email" />
                </span>
                {emailAddress}
              </a>
              <a href={whatsappLink} target="_blank" rel="noreferrer noopener">
                <span aria-hidden="true">
                  <FooterInfoIcon type="whatsapp" />
                </span>
                {whatsappNumber}
              </a>
            </div>

            <button
              type="button"
              className={`menu-toggle ${menuOpen ? 'open' : ''}`}
              aria-label="Toggle navigation menu"
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((prev) => !prev)}
            >
              <span />
              <span />
              <span />
            </button>
          </div>
        </div>

        <div className="container nav-wrap">
          <a
            className="brand"
            href="#home"
            aria-label="Edinburghtaxicabs home"
            onClick={(event) => handleNavClick(event, '#home')}
          >
            <span className="brand-logo-shell">
              <img src="/logo.png" alt="Edinburghtaxicabs logo" className="brand-logo" />
            </span>
            <span className="brand-text">
              <strong>Edinburgh Taxi Cabs</strong>
              <small>Reliable City & Airport Taxi Service</small>
            </span>
          </a>

          <nav className={`main-nav ${menuOpen ? 'open' : ''}`} aria-label="Primary navigation">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={(event) => handleNavClick(event, item.href)}
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      </header>

      <main>
        <section className="hero" id="home">
          <div className="hero-overlay" />
          <div className="container hero-content">
            <p className="hero-kicker">Trusted In Edinburgh</p>
            <p>
              Experience smooth, safe, and reliable rides with Edinburg Taxicabs. Whether
              you are heading to work, the airport, or exploring the city, we ensure comfort
              and punctual service every time. Your journey matters to us, and we are here
              24/7 to get you there hassle-free.
            </p>

            <div className="hero-actions" role="group" aria-label="Primary actions">
              {ctaItems.map((item) => (
                <a
                  key={item.label}
                  className={`cta ${item.className}`}
                  href={item.href}
                  target={item.external ? '_blank' : undefined}
                  rel={item.external ? 'noreferrer noopener' : undefined}
                >
                  <span className="cta-icon" aria-hidden="true">
                    <ButtonIcon type={item.icon} />
                  </span>
                  {renderCtaLabel(item.label)}
                </a>
              ))}
            </div>
          </div>
        </section>

        {!selectedService && !selectedAirport ? (
          <>
            <section className="section" id="about">
              <div className="container about-layout">
                <div className="about-content">
                  <h2>About Us</h2>
                  <p>
                    Welcome to Edinburg Taxicabs, your trusted choice for reliable and
                    comfortable transportation in Edinburgh. We are dedicated to providing safe,
                    punctual, and convenient taxi services for both local travel and airport
                    transfers.
                  </p>
                  <p>
                    At Edinburg Taxicabs, we understand the importance of time and comfort.
                    Whether you are heading to work, catching a flight, or exploring the city,
                    our goal is to make your journey smooth and stress-free. Our drivers are
                    experienced, friendly, and committed to delivering a pleasant travel
                    experience every time.
                  </p>
                  <p>
                    We operate 24/7 to ensure that you always have a ride when you need it. With
                    a focus on safety, reliability, and customer satisfaction, Edinburg Taxicabs
                    is here to serve you anytime, anywhere across Edinburgh.
                  </p>
                  <p className="about-highlight">
                    Choose Edinburg Taxicabs for a journey you can rely on.
                  </p>
                  <a
                    className="about-learn-more"
                    href="https://booktaxinow.co.uk/"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    Learn More
                  </a>
                </div>

                <div className="about-visual" aria-hidden="true">
                  <img src="/aboutus.webp" alt="Edinburgh taxi service" />
                </div>
              </div>
            </section>

            <section className="section section-alt" id="services">
              <div className="container">
                <p className="section-kicker">What We Offer</p>
                <h2>Our Services</h2>
                <div className="services-grid">
                  {services.map((service) => (
                    <article key={service.title} className="svc-card">
                      <div className="svc-img-placeholder" aria-hidden="true">
                        {service.img ? <img src={service.img} alt={service.title} /> : <span>Image</span>}
                      </div>
                      <div className="svc-body">
                        <h3>{service.title}</h3>
                        <p>{service.desc}</p>
                        <button
                          type="button"
                          className="svc-learn-more"
                          onClick={() => handleOpenService(service)}
                        >
                          {service.title}
                        </button>
                      </div>
                    </article>
                  ))}
                </div>
              </div>
            </section>

            {!selectedAirport ? (
              <section className="section" id="airport-transfers">
                <div className="container">
                  <h2>Airport Transfers</h2>
                  <div className="airport-feature">
                    <div className="airport-feature-image-wrap">
                      <img src="/slider.webp" alt="Airport transfer service" className="airport-feature-image" />
                    </div>
                    <div className="airport-feature-content">
                      <p>
                        Edinburg Taxicabs provides reliable and professional airport transfer services
                        in Edinburg, ensuring a smooth and stress-free journey for every passenger.
                        Edinburg Taxicabs focuses on punctuality, offering on-time pickups and
                        drop-offs so you never have to worry about missing a flight. With experienced
                        drivers and comfortable vehicles, Edinburg Taxicabs guarantees a safe and
                        relaxing travel experience. Whether you are traveling for business or leisure,
                        Edinburg Taxicabs makes airport transportation simple, convenient, and
                        dependable. Additionally, Edinburg Taxicabs monitors flight schedules to
                        adjust pickup times according to delays or early arrivals, ensuring maximum
                        convenience for customers.
                      </p>
                    </div>
                  </div>

                  <div className="airport-cards-grid">
                    {airportTransferCards.map((airport) => (
                      <article key={airport.title} className="airport-transfer-card">
                        <h3>{airport.title}</h3>
                        <p>{airport.summary}</p>
                        <button
                          type="button"
                          className="airport-read-more"
                          onClick={() => handleReadAirport(airport)}
                        >
                          Read More
                        </button>
                      </article>
                    ))}
                  </div>
                </div>
              </section>
            ) : null}

            <section className="section section-alt" id="contact">
              <div className="container">
                <div className="contact-simple">
                  <div className="contact-simple-main">
                    <span className="contact-simple-icon" aria-hidden="true">
                      <FooterInfoIcon type="phone" />
                    </span>
                    <div className="contact-simple-copy">
                      <h2>Have a question or need a custom quote?</h2>
                      <p>
                        We are open 24 hours through out the year. Call us anytime at{' '}
                        <a href={`tel:${callTel}`}>{callNumber}</a>
                      </p>
                    </div>
                  </div>

                  <div className="contact-simple-visual" aria-hidden="true" />
                </div>

                <div className="contact-simple-meta">
                  <span>
                    <strong>Address:</strong> Edinburgh
                  </span>
                  <span>
                    <strong>Email:</strong> <a href={`mailto:${emailAddress}`}>{emailAddress}</a>
                  </span>
                  <span>
                    <strong>WhatsApp:</strong>{' '}
                    <a href={whatsappLink} target="_blank" rel="noreferrer noopener">
                      {whatsappNumber}
                    </a>
                  </span>
                </div>
              </div>
            </section>

            <section className="section testimonials-section" id="testimonials">
              <div className="container testimonials-wrap">
                <p className="section-kicker">Client Feedback</p>
                <h2>Testimonials</h2>

                <div className="testimonials-slider" aria-live="polite">
                  {testimonials.map((item, index) => (
                    <article
                      key={`${item.name}-${index}`}
                      className={`testimonial-card ${index === activeTestimonialIndex ? 'active' : ''}`}
                      aria-hidden={index === activeTestimonialIndex ? 'false' : 'true'}
                    >
                      <p className="testimonial-quote">"{item.quote}"</p>
                      <p className="testimonial-author">
                        {item.name} - {item.location}
                      </p>
                    </article>
                  ))}
                </div>

                <div className="testimonial-dots" role="tablist" aria-label="Testimonials Slider Dots">
                  {testimonials.map((item, index) => (
                    <button
                      key={`${item.name}-dot-${index}`}
                      type="button"
                      role="tab"
                      aria-selected={index === activeTestimonialIndex}
                      aria-label={`Show review ${index + 1}`}
                      className={`testimonial-dot ${index === activeTestimonialIndex ? 'active' : ''}`}
                      onClick={() => setActiveTestimonialIndex(index)}
                    />
                  ))}
                </div>
              </div>
            </section>
          </>
        ) : selectedService ? (
          <section className="section section-alt service-detail-page" id="service-detail-page">
            <div className="container">
              <button type="button" className="svc-back-btn" onClick={handleBackToServices}>
                Back To Services
              </button>
              <div className="service-detail-card">
                <div className="service-detail-image-wrap">
                  <img src={selectedService.img} alt={selectedService.title} className="service-detail-image" />
                </div>
                <div className="service-detail-content">
                  <h2>{selectedService.title}</h2>
                  <p>{selectedService.detail}</p>
                </div>
              </div>

              <div className="service-detail-contact-strip">
                <div className="contact-simple">
                  <div className="contact-simple-main">
                    <span className="contact-simple-icon" aria-hidden="true">
                      <FooterInfoIcon type="phone" />
                    </span>
                    <div className="contact-simple-copy">
                      <h2>Have a question or need a custom quote?</h2>
                      <p>
                        We are open 24 hours through out the year. Call us anytime at{' '}
                        <a href={`tel:${callTel}`}>{callNumber}</a>
                      </p>
                    </div>
                  </div>

                  <div className="contact-simple-visual" aria-hidden="true" />
                </div>

                <div className="contact-simple-meta">
                  <span>
                    <strong>Address:</strong> Edinburgh
                  </span>
                  <span>
                    <strong>Email:</strong> <a href={`mailto:${emailAddress}`}>{emailAddress}</a>
                  </span>
                  <span>
                    <strong>WhatsApp:</strong>{' '}
                    <a href={whatsappLink} target="_blank" rel="noreferrer noopener">
                      {whatsappNumber}
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </section>
        ) : selectedAirport ? (
          <section className="section section-alt airport-detail-page" id="airport-detail-page">
            <div className="container">
              <button
                type="button"
                className="airport-back-btn"
                onClick={() => {
                  window.location.hash = 'airport-transfers';
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
              >
                Back To Airport Transfers
              </button>
              <div className="airport-transfer-detail-card-full">
                <h2>{selectedAirport.title}</h2>
                <p>{selectedAirport.description}</p>
              </div>

              <div className="airport-transfer-detail-contact">
                <div className="contact-simple">
                  <div className="contact-simple-main">
                    <span className="contact-simple-icon" aria-hidden="true">
                      <FooterInfoIcon type="phone" />
                    </span>
                    <div className="contact-simple-copy">
                      <h2>Need airport booking assistance?</h2>
                      <p>
                        We are open 24 hours through out the year. Call us anytime at{' '}
                        <a href={`tel:${callTel}`}>{callNumber}</a>
                      </p>
                    </div>
                  </div>

                  <div className="contact-simple-visual" aria-hidden="true" />
                </div>

                <div className="contact-simple-meta">
                  <span>
                    <strong>Address:</strong> Edinburgh
                  </span>
                  <span>
                    <strong>Email:</strong> <a href={`mailto:${emailAddress}`}>{emailAddress}</a>
                  </span>
                  <span>
                    <strong>WhatsApp:</strong>{' '}
                    <a href={whatsappLink} target="_blank" rel="noreferrer noopener">
                      {whatsappNumber}
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </section>
        ) : null}
      </main>

      <footer className="site-footer">
        <div className="container footer-wrap">
          <div className="footer-brand">
            <img src="/logo.png" alt="Edinburghtaxicabs logo" className="footer-logo" />
            <h3>Edinburgh Taxi Cabs</h3>
            <p>
              Professional city and airport transfer service with trained drivers, clean
              vehicles, and on-time arrivals.
            </p>
          </div>

          <div className="footer-links">
            <h3>Quick Links</h3>
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={(event) => handleNavClick(event, item.href)}
              >
                {item.label}
              </a>
            ))}
          </div>

          <div className="footer-contact">
            <h3>Contact Details</h3>
            <div className="footer-contact-list">
              <p>
                <span className="info-icon" aria-hidden="true">
                  <FooterInfoIcon type="address" />
                </span>
                <span>Edinburgh</span>
              </p>
              <p>
                <span className="info-icon" aria-hidden="true">
                  <FooterInfoIcon type="email" />
                </span>
                <span>
                  <a href={`mailto:${emailAddress}`}>{emailAddress}</a>
                </span>
              </p>
              <p>
                <span className="info-icon" aria-hidden="true">
                  <FooterInfoIcon type="phone" />
                </span>
                <span>
                  <a href={`tel:${callTel}`}>{callNumber}</a>
                </span>
              </p>
              <p>
                <span className="info-icon" aria-hidden="true">
                  <FooterInfoIcon type="whatsapp" />
                </span>
                <span>
                  <a href={whatsappLink} target="_blank" rel="noreferrer noopener">
                    {whatsappNumber}
                  </a>
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="footer-bottom">© 2026 Edinburghtaxicabs. All rights reserved.</div>
      </footer>

      <div className="floating-contact" aria-label="Quick contact actions">
        <a className="float-btn float-call" href={`tel:${callTel}`} aria-label="Call now">
          <FooterInfoIcon type="phone" />
          <span className="float-call-text">Call Now</span>
          <span className="float-call-number">{callNumber}</span>
        </a>
        <a
          className="float-btn float-whatsapp"
          href={whatsappLink}
          target="_blank"
          rel="noreferrer noopener"
          aria-label="Chat on WhatsApp"
        >
          <span className="float-whatsapp-label">Chat With Us</span>
          <FooterInfoIcon type="whatsapp" />
        </a>
      </div>
    </div>
  );
}

export default App;
